import EnumValueNotFoundException from '~/errors/EnumValueNotFoundException';

import { log } from '~/utils/logging';

import {
  DATA_SUBSCRIPTION_FILTER_CLAUSE_FILTER_KEYWORD,
  DATA_SUBSCRIPTION_FILTER_CLAUSE_VALUE_TYPE,
} from './constants';
import {
  type DataSubscriptionFilterClause,
  type DataSubscriptionFilterClauseFilterKeywordKeys,
} from './types';

export const DataSubscriptionFilterClauseObject = {
  /**
   * Creates a new DataSubscriptionFilterClause object.
   * @param {Partial<DataSubscriptionFilterClause>} filterClause - The data for initializing the clause.
   * @returns {DataSubscriptionFilterClause} The initialized clause object.
   */
  create(filterClause: Partial<DataSubscriptionFilterClause> = { value: '' }) {
    return {
      filterKeyword:
        filterClause?.filterKeyword ?? this.FILTER_KEYWORD.DLN_NR.KEY,
      id:
        filterClause?.id ??
        (filterClause?.filterKeyword?.toLowerCase() ??
          this.FILTER_KEYWORD.DLN_NR.KEY.toLowerCase()) +
          '-' +
          Math.floor(Math.random() * 1000000),
      value: filterClause?.value,
      valueType: this.VALUE_TYPE,
    };
  },

  FILTER_KEYWORD: DATA_SUBSCRIPTION_FILTER_CLAUSE_FILTER_KEYWORD,

  /**
   * Converts the filter clause into a backend-compatible format.
   * @param {DataSubscriptionFilterClause} filterClause - The clause to format.
   * @returns {Record<string, any>} The formatted clause object.
   */
  getBackendFormat(filterClause: Record<string, any>) {
    return {
      filter_keyword: filterClause.filterKeyword,
      value: filterClause.value,
      value_type: filterClause.valueType,
    };
  },

  /**
   * Retrieves the filter keyword string based on the provided filter key.
   * @param {string} filterKey - The key of the filter.
   * @returns {string | null} The filter keyword string or null if not found.
   */
  getFilterKeywordString(filterKey: string) {
    const filter = Object.keys(this.FILTER_KEYWORD).find(
      (key) =>
        this.FILTER_KEYWORD[
          key as DataSubscriptionFilterClauseFilterKeywordKeys
        ].KEY === filterKey,
    );

    if (!filter) {
      log.error({
        message: `Invalid filter: ${filterKey}`,
        error: new EnumValueNotFoundException(`Invalid filter: ${filterKey}`),
      });
      return null;
    }

    return this.FILTER_KEYWORD[
      filter as DataSubscriptionFilterClauseFilterKeywordKeys
    ].STRING;
  },

  VALUE_TYPE: DATA_SUBSCRIPTION_FILTER_CLAUSE_VALUE_TYPE,
};
